<div class="card card-tabs">
	<div class="card-body">
		<label for="" class="title-history">
			Operaciones
		</label>
		<div class="pcss3t pcss3t-effect-scale pcss3t-theme-1">
			<input type="radio" name="pcss3t" [appCheckPermission]="[5047,5017]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(0)"
				[(ngModel)]="history" [value]="0" checked id="tab1">
			<label for="tab1" [appCheckPermission]="[5047,5017]" [permissionType]="permissionType.ALL">
				<i class="bx bxs-shopping-bag"></i>Ventas
			</label>

			<input type="radio" [appCheckPermission]="[5047,5023]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(1)" name="pcss3t"
				[(ngModel)]="history" [value]="1" id="tab2" class="tab-content-2">
			<label for="tab2" [appCheckPermission]="[5047,5023]" [permissionType]="permissionType.ALL">
				<i class="fa fa-tag"></i>Compras
			</label>

			<input type="radio" [appCheckPermission]="[5047,5018]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(2)" name="pcss3t"
				[(ngModel)]="history" [value]="2" id="tab3">
			<label for="tab3" [appCheckPermission]="[5047,5018]" [permissionType]="permissionType.ALL">
				<i class="bx bx-detail"></i>Cotizaciones
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="3" id="tab4"
				[appCheckPermission]="[5047,5041]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(3)">
			<label for="tab4" [appCheckPermission]="[5047,5041]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-hand-holding-dollar"></i>Gastos
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="8" id="tab9"
				[appCheckPermission]="[5047,5094]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(8)">
			<label for="tab9" [appCheckPermission]="[5047,5094]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-file-invoice-dollar"></i>Retenciones
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="4" id="tab5"
				[appCheckPermission]="[5047,5038]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(4)">
			<label for="tab5" [appCheckPermission]="[5047,5038]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-copy"></i>Partidas
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="5" id="tab6"
				[appCheckPermission]="[5047,5039]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(5)">
			<label for="tab6" [appCheckPermission]="[5047,5039]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-sack-dollar"></i>Bolsa
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="6" id="tab7"
				[appCheckPermission]="[5047,5046]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(6)">
			<label for="tab7" [appCheckPermission]="[5047,5046]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-boxes"></i>Inventarios
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="7" id="tab8"
				[appCheckPermission]="[5047,5054]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(7)">
			<label for="tab8" [appCheckPermission]="[5047,5054]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-people-carry-box"></i>Traslados
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="9" id="tab10"
				[appCheckPermission]="[5047,5095]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(9)">
			<label for="tab10" [appCheckPermission]="[5047,5095]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-xmark"></i>Anular
			</label>

			<input type="radio" name="pcss3t" [(ngModel)]="history" [value]="10" id="tab11"
				[appCheckPermission]="[5047,5041]" [permissionType]="permissionType.ALL" (click)="updateIndexParam(10)">
			<label for="tab11" [appCheckPermission]="[5047,5041]" [permissionType]="permissionType.ALL">
				<i class="fa-solid fa-file-invoice"></i>Anticipos
			</label>

		</div>
		<app-history-sales [hidden]="history!=0" *ngIf="history==0"></app-history-sales>
		<app-history-purchases [warehouseList]="warehouseList" [warehouseNames]="warehouseNames"
			[hidden]="history!=1" *ngIf="history==1"></app-history-purchases>
		<app-history-coti
			[hidden]="history!=2" *ngIf="history==2"></app-history-coti>
		<app-history-docs [hidden]="history!=3" *ngIf="history==3"></app-history-docs>
		<app-history-accounting-entries [hidden]="history!=4" *ngIf="history==4"></app-history-accounting-entries>
		<app-history-invoice-bag [hidden]="history!=5" *ngIf="history==5"></app-history-invoice-bag>
		<app-history-inventory [hidden]="history!=6" *ngIf="history==6"></app-history-inventory>
		<app-history-transfer-products [hidden]="history!=7" *ngIf="history==7"></app-history-transfer-products>
		<app-history-withholdings [hidden]="history!=8" *ngIf="history==8"></app-history-withholdings>
		<app-history-annul-sales [hidden]="history!=9" *ngIf="history==9"></app-history-annul-sales>
		<app-history-advance-payment [hidden]="history!=10" *ngIf="history==10"></app-history-advance-payment>
	</div>
</div>